<template>
  <div class="container-fluid as-container">
    <nav class="navbar navbar-expand-lg navbar-light bg-filled" :class="navClassBg">
      <router-link class="navbar-brand" :to="`/${locale}`">
        <span class="ribbon2">
          <img src="../assets/images/logo.svg" />
        </span>
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        @click.prevent="navCollapse('nav-collapse')"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="collapse navbar-collapse"
        id="nav-collapse"
        @click="navCollapse('nav-collapse')"
      >
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <router-link class="nav-link" :to="`/${locale}`">
              {{ $t("nav.main") }}
              <span class="sr-only">(current)</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${locale}/about`">{{
              $t("nav.about_us")
            }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${locale}/projects`">{{
              $t("nav.projects")
            }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${locale}/references`">{{
              $t("nav.references")
            }}</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="`/${locale}/licenses-and-certificates`"
              >{{ $t("nav.licenses_and_certificates") }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${locale}/news`">{{
              $t("nav.news")
            }}</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" :to="`/${locale}/contacts`">{{
              $t("nav.contact")
            }}</router-link>
          </li> -->
        </ul>
        <div class="form-inline as-top-right">
          <div class="dropdown">
            <b-dropdown class="btn-lang" :text="lang">
              <b-dropdown-item :to="{ params: { locale: 'uk' } }"
                >УКР</b-dropdown-item
              >
              <b-dropdown-item :to="{ params: { locale: 'ru' } }"
                >РУС</b-dropdown-item
              >
              <b-dropdown-item :to="{ params: { locale: 'eng' } }"
                >ENG</b-dropdown-item
              >
              <b-dropdown-item :to="{ params: { locale: 'pl' } }"
                >PL</b-dropdown-item
              >
              <b-dropdown-item :to="{ params: { locale: 'de' } }"
                >DE</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <!--<div class="toll_free">
            <div class="tf_in">
              <p>
                <span>КАЧЕСТВЕННО И В СРОК</span>
              </p>
            </div>
          </div>-->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
// import HomeSlider from "@/components/HomeSlider.vue";
// import AnchorRouterLink from "vue-anchor-router-link";
export default {
  computed: {
    lang() {
      let str = "";
      if (this.$route.params.locale === "uk") {
        str = "Українська";
      } else if (this.$route.params.locale === "eng") {
        str = "English";
      } else if (this.$route.params.locale === "pl") {
        str = "Polskie";
      } else if (this.$route.params.locale === "de") {
        str = "Deutsche";
      } else {
        str = "Русский";
      }
      return str;
    },
  },
  data() {
    return {
      locale: this.$route.params.locale,
      navClassBg: null,
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    // HomeSlider,
    // AnchorRouterLink
  },
  methods: {
    changeLangLink(e) {
      return window.location.pathname.replace(this.$i18n.locale, e);
    },
    handleScroll() {
      if (window.scrollY > 400) {
        this.navClassBg = "bg-filled";
      } else {
        this.navClassBg = null;
      }
    },
    navCollapse(target) {
      const t = document.getElementById(target);
      if (!t.classList.contains("show")) {
        t.classList.add("show");
      } else {
        t.classList.remove("show");
      }
    },
  },
};
</script>

<style>
.navbar {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed !important;
  top: 0;
  width: 100%;
  z-index: 1060;
  transition: all 1s;
}
.navbar .nav-item {
  background: transparent;
  transition: background 0.5s;
}
.navbar .nav-item:hover {
  background: #5a6268;
}

.navbar.bg-filled {
  background-color: #333;
}
.navbar .navbar-nav {
  height: 86px;
  line-height: 68px;
}
.navbar .nav-item {
  padding: 0 10px;
}
.navbar .nav-link {
  color: #fff !important;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 400;
}
.navbar-brand {
  margin-left: 30px;
  color: #fff !important;
  width: 100px;
}
.navbar-brand img {
  width: auto;
  max-height: 80px;
}
.ribbon2 {
  width: 100px;
  padding: 6px 0 !important;
  position: absolute;
  top: 0px;
  left: 25px;
  text-align: center;
  border-top-left-radius: 3px;
  background: #316397;
}
.ribbon2:before,
.ribbon2:after {
  content: "";
  position: absolute;
}
.ribbon2:after {
  height: 0;
  width: 0;
  bottom: -29.5px;
  left: 0;
  border-left: 50px solid #316397;
  border-right: 50px solid #316397;
  border-bottom: 30px solid transparent;
}
.navbar,
.as-container {
  padding: 0 !important;
}
.btn-lang button {
  background: transparent;
  border: 0;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
}
.toll_free {
  padding: 22px 0;
  position: relative;
}
.toll_free span.shape1:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 46px;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1;
}
.toll_free span.shape1:after {
  content: "";
  position: absolute;
  top: 9px;
  bottom: 9px;
  right: 0;
  left: 23px;
  background-color: #d24e1a;
  z-index: 1;
}
.toll_free .shape2 {
  position: absolute;
  left: 0;
  top: 9px;
  border-top: 68px solid transparent;
  border-right: 23px solid #d24e1a;
}
.toll_free .shape3 {
  position: absolute;
  left: 23px;
  top: 0;
  border-top: 86px solid transparent;
  border-right: 23px solid rgba(0, 0, 0, 0.1);
}
.toll_free .tf_in {
  position: relative;
  padding-left: 34px;
  padding-right: 34px;
  min-height: 42px;
  display: flex;
  align-items: center;
  z-index: 5;
  text-transform: uppercase;
}
.toll_free .img_holder {
  position: absolute;
  width: 42px;
  height: 42px;
  border-radius: 100%;
  left: 43px;
  background-image: url("../assets/call.png");
}
.toll_free span.shape1:after {
  background: #d24e1a !important;
}
.toll_free .tf_in p {
  margin: 0;
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
}
.as-top-right {
  margin-right: 30px;
}
.as-top-right .dropdown-menu {
  left: unset !important;
  right: 0 !important;
}
@media (max-width: 768px) {
  .as-top-right .dropdown-menu {
    left: 0 !important;
    right: 0 !important;
  }
}
@media (min-width: 768px) and (max-width: 1280px) {
  .navbar .nav-link {
    font-size: 13px;
  }
  .navbar .dropdown-toggle {
    font-size: 16px;
  }
  .navbar .navbar-brand {
    margin: 0;
    padding: 0;
  }
  .navbar .ribbon2 {
    width: 70px;
    padding: 3px 0 !important;
  }
  .navbar .ribbon2:after {
    content: none;
    border-left: 35px solid #316397;
    border-right: 35px solid #316397;
  }
  .navbar .nav-item {
    padding: 0;
  }
}
</style>
